import {RouteComponentProps} from 'react-router-dom';
import Loader from '@components/framework/loader/Loader';
import React from 'react';
import {verifyGuarantorCodeToken} from '@shared/services/Payment.service';
import NavRoutes from '../../../constants/route/NavRoutes';
import {SnackBarConfig} from '../../../utils/SnackBarConfig';
import {useSnackbar} from 'notistack';
import {GuarantorPortalsTypesMap} from '@shared/constants/Mapping';

const PaymentRedirect = (
  props: RouteComponentProps<{code: string; practiceShortCode: string}>
): React.ReactElement => {
  const {enqueueSnackbar} = useSnackbar();

  const {history, match} = props;

  const loginRedirect = React.useCallback(
    (token: string): void => {
      const search = props.location?.search || '';
      history.push(
        `/${NavRoutes.PUBLIC.PAYMENTS_LOGIN}/pay/${token}${search}`
      );
    },
    [history, props.location?.search]
  );

  const errorRedirect = React.useCallback(
    (errorMessage?: string): void => {
      history.push(`/${NavRoutes.PUBLIC.ERROR_PAY}`, {errorMessage});
    },
    [history]
  );

  React.useEffect(() => {
    if (match.params.code) {
      verifyGuarantorCodeToken(
        match.params.code,
        GuarantorPortalsTypesMap.GUARANTOR
      )
        .then(res => {
          if (res?.data?.token) {
            loginRedirect(res.data.token);
          }
        })
        .catch(err => {
          if (err.message) {
            enqueueSnackbar(err.message, SnackBarConfig('e'));
          }
          errorRedirect(err?.message);
        });
    } else if (match.params.practiceShortCode) {
      verifyGuarantorCodeToken(
        match.params.practiceShortCode,
        GuarantorPortalsTypesMap.PRACTICE
      )
        .then(res => {
          if (res?.data?.token) {
            loginRedirect(res.data.token);
          }
        })
        .catch(err => {
          if (err.message) {
            enqueueSnackbar(err.message, SnackBarConfig('e'));
          }
          errorRedirect(err?.message);
        });
    }
  }, [
    loginRedirect,
    errorRedirect,
    match.params.code,
    match.params.practiceShortCode,
    enqueueSnackbar
  ]);

  return (
    <div className="flex-centering">
      <Loader size={56} color="primary" />
    </div>
  );
};

export default PaymentRedirect;
